import api from "api";
import { useCallback, useEffect, useState } from "react";
import { CustomSaveAgreementObject, ProjectTypeType, Bin, Project } from "types";
import "./new-project.scss";
import ProjectTypeBlock from "../../../components/app/projects/project-type-block";
import AccountManagement from "../../../components/app/account";
import { ContactManagementType } from "types/contact-management";
import { useHistory, useParams } from "react-router-dom";

function NewProject() {
  // Before steps
  const params: any = useParams();
  const history = useHistory();
  const [projectTypes, setProjectTypes] = useState<ProjectTypeType[]>([]);
  const [step, setStep] = useState<number>(1);

  // Step 1
  const [type, setType] = useState<number>(0);
  const [subProjectTypes, setSubProjectTypes] = useState<ProjectTypeType[]>([]);
  const [expanded, setExpanded] = useState<boolean>(false);
  const [step2, setStep2] = useState<string>("");
  const [step3Items, setStep3Items] = useState<ProjectTypeType[]>(projectTypes);
  const [step3TotalAmountPrice, setStep3TotalAmountPrice] = useState<any | number>(0);
  const [step3SubTotalAmountPrice, setStep3SubTotalAmountPrice] = useState<any | number>(0);
  const [step3TotalVatPrice, setStep3TotalVatPrice] = useState<any | number>(0);
  const [contacts, setContacts] = useState<ContactManagementType[]>([]);

  // Step 3
  const [requestedBy, setRequestedBy] = useState();
  const [billingType, setBillingType] = useState();
  const [paymentType, setPaymentType] = useState();
  const [cancellationType, setCancellationType] = useState<number | undefined>();
  const [agreementStartDate, setAgreementStartDate] = useState<string>();
  const [agreementEndDate, setAgreementEndDate] = useState<string | null>();
  const [isTrail, setIsTrail] = useState<boolean>(false);
  const [sendAgreementNow, setSendAgreementNow] = useState<boolean>(true);

  const setStep3States = async (stateName: string, value: any) => {
    if (stateName == "bequestedBy") {
      setRequestedBy(value);
    }
    if (stateName == "billingType") {
      setBillingType(value);
    }
    if (stateName == "paymentType") {
      setPaymentType(value);
    }
    if (stateName == "cancellationType") {
      setCancellationType(value);
    }
    if (stateName == "agreementStartDate") {
      setAgreementStartDate(value);
    }
    if (stateName == "agreementEndDate") {
      setAgreementEndDate(value);
    }
    if (stateName == "IsTrail") {
      setIsTrail(value);
    }
    if (stateName == "SendAgreementNow") {
      setSendAgreementNow(value);
    }
  };

  const ValidateStep = async () => {
    if (step === 3) {
      if (requestedBy === undefined) {
        alert("Please select a valid requested by");
        return;
      }
      if (billingType === undefined) {
        alert("Please select a valid billing type by");
        return;
      }
      if (paymentType === undefined) {
        alert("Please select a valid payment type by");
        return;
      }
      if (cancellationType === undefined) {
        alert("Please select a valid cancellation type by");
        return;
      }
      if (agreementStartDate === undefined) {
        alert("Please select a valid start date by");
        return;
      }
      if (agreementEndDate === undefined) {
        setAgreementEndDate(null);
      }
      setStep(step + 1);
    }
    if (step == 4) {
      var ProductList = new Array();

      for (const x of step3Items) {
        ProductList.push({
          Id: x.Id,
          ProductId: x.Id,
          Description: x.Description,
          Quantity: x.Amount,
          Price: x.Price,
        });
      }
      if (!agreementStartDate || !requestedBy) {
        return;
      }

      if (!cancellationType) {
        return;
      }
      var agreement = {
        ClientId: parseInt(params.clientId),
        AccountId: 0,
        CancellationTypeId: cancellationType,
        RequestedById: parseInt(requestedBy),
        CurrencyId: "ZAR",
        StartDate: new Date(agreementStartDate),
        EndDate: agreementEndDate == null ? null : new Date(agreementEndDate),
        AgreementTotal: step3TotalAmountPrice,
        IsTrial: isTrail,
        Products: JSON.stringify(ProductList),
        ProductListTotal: step3TotalAmountPrice,
        SendAgreementNow: sendAgreementNow,
        IsFixedAgreement: true,
        IsPerMonthCosting: false,
        ProductListFixedPrice: step3TotalAmountPrice,
        BillingTypeId: billingType,
        InvoiceGroupId: 0,
        PaymentTypeId: paymentType,
        ProjectType: type,
      } as CustomSaveAgreementObject;

      var Bin = {
        Id: 0,
        Name: step2,
        ParentId: 0,
        StreamId: 0,
        DateCreated: new Date(),
        DateModified: new Date(),
        IsDeleted: false,
        ClientId: parseInt(params.clientId),
        ForeignId: 0,
      } as Bin;

      var Project = {
        BinId: 0,
        ProjectTypeId: 0,
        ProjectSubTypeId: 0,
        CompetitorToProjectId: null,
      } as Project;

      var sendItem = {
        agreement: agreement,
        bin: Bin,
        project: Project,
      };

      api.agreementProjectSetup.InsertAgreementProject(sendItem, type).then(function () {
        history.replace("projects");
      });
    }
    setStep(step + 1);
  };

  const checValue = async (value: any) => { };

  const getProjectTypesOnLoad = useCallback(async () => {
    var projectTypes = await api.project.getProjectTypes(0);
    setProjectTypes(projectTypes);
  }, []);

  const getContacts = useCallback(() => {
    api.contact.getAllByClientId(params.clientId).then((data) => {
      setContacts(data);
    });
  }, [params.clientId]);

  const GetProjectTypes = (parentId: number) => {
    var newstate = new Array<any>();
    api.project.getProjectTypes(parentId).then((data) => {
      for (var i of data) {
        newstate.push(i);
      }
      setSubProjectTypes(newstate);
    });
    return subProjectTypes;
  };

  const AddItemToTotal = (product: ProjectTypeType) => {
    var newState = step3Items;
    const checkExist = (roleParam: any) => newState.some(({ Id }) => Id == roleParam);
    var exsists = checkExist(product.Id);

    if (!exsists) {
      newState.push(product);
      setStep3Items(newState);
      CalculateSetTotal();
    } else {
      newState.map((x) => {
        if (x.Id === product.Id) {
          x.Amount = product.Amount;
        }
      });
      setStep3Items(newState);
      CalculateSetTotal();
    }
  };

  const CalculateSetTotal = () => {
    var SubTotalAmount = 0;
    var TotalAmount = 0;
    var VAT = 0;

    step3Items.map((x) => {
      var ItemPrice = x.Amount != 0 ? x.Price * x.Amount : 0;
      SubTotalAmount += parseFloat(ItemPrice.toFixed(2));
    });

    VAT = SubTotalAmount * 0.15;
    TotalAmount = SubTotalAmount + VAT;
    setStep3SubTotalAmountPrice(SubTotalAmount.toFixed(2));
    setStep3TotalVatPrice(VAT.toFixed(2));
    setStep3TotalAmountPrice(TotalAmount.toFixed(2));
  };

  useEffect(() => {
    getProjectTypesOnLoad();
  }, [getProjectTypesOnLoad]);

  useEffect(() => {
    getContacts();
  }, [getContacts]);

  return (
    <div className="new-project">
      <div className={`side ${expanded ? "expanded" : ""}`}>
        <div className={`step ${step === 1 ? "active" : step > 1 ? "completed" : ""}`} onClick={() => setStep(1)}>
          <span>1</span>
          <p>Project Type</p>
          <i className="fas fa-check-circle"></i>
        </div>
        <div className={`step ${step === 2 ? "active" : step > 2 ? "completed" : ""}`}>
          <span>2</span>
          <p>Project Name</p>
          <i className="fas fa-check-circle"></i>
        </div>
        <div className={`step ${step === 3 ? "active" : step > 3 ? "completed" : ""}`}>
          <span>3</span>
          <p>Account setup</p>
          <i className="fas fa-check-circle"></i>
        </div>
        <div className={`step ${step === 4 ? "active" : step > 4 ? "completed" : ""}`}>
          <span>4</span>
          <p>Agreement setup</p>
          <i className="fas fa-check-circle"></i>
        </div>
        {expanded ? <i className="fal fa-angle-double-left" onClick={() => setExpanded(false)}></i> : <i className="fal fa-angle-double-right" onClick={() => setExpanded(true)}></i>}
      </div>
      <div className="main">
        {step === 1 && (
          <div className="step step-1">
            <h2>Please select a project type:</h2>
            <div className="blocks">
              {projectTypes.map((x: ProjectTypeType, i: number) => (
                <div
                  key={i}
                  className="project-type-block project-selection-option"
                  onClick={() => {
                    setStep(step + 1);
                    setType(x.Id);
                    GetProjectTypes(x.Id);
                  }}
                >
                  {/* <img src={`${process.env.PUBLIC_URL}/img/placeholder.jpg`} alt="" /> */}
                  <p>{x.Description}</p>
                </div>
              ))}
            </div>
          </div>
        )}
        {step === 2 && (
          <div className="step step-2">
            <h2>Please provide a name:</h2>
            <input type="text" value={step2} placeholder="Name" onChange={(e) => setStep2(e.currentTarget.value)} />
          </div>
        )}
        {step === 3 && (
          <div className="step step-3" style={{ position: "relative" }}>
            <h2 style={{ marginBottom: "10px" }}>Account management</h2>
            <AccountManagement setStep3States={setStep3States} isTrail={isTrail} sendAgreementNow={sendAgreementNow} />
          </div>
        )}
        {step === 4 && (
          <div className="step step-3" style={{ position: "relative" }}>
            <h2 style={{ marginBottom: "10px" }}>Agreement management</h2>
            <div style={{ float: "right", width: "100%" }}>
              <span style={{ float: "right" }}>
                <h3>
                  <span style={{ float: "left", marginRight: "25px" }}>SubTotal:</span>
                  <span style={{ paddingRight: "42px" }}>R{step3SubTotalAmountPrice}</span>
                </h3>
                <h3>
                  <span style={{ float: "left", marginRight: "25px" }}>VAT:</span>
                  <span style={{ paddingRight: "42px" }}>R{step3TotalVatPrice}</span>
                </h3>
                <h3>
                  <span style={{ float: "left" }}>Total:</span>
                  <span style={{ paddingRight: "42px" }}>R{step3TotalAmountPrice}</span>
                </h3>
              </span>
            </div>
            <div>
              {subProjectTypes.map((x: ProjectTypeType) => (
                <ProjectTypeBlock ProductType={x} AddItemToTotal={AddItemToTotal} contactsCount={contacts.length} />
              ))}
            </div>
            <br />
            <br />
            <br />
            <br />
          </div>
        )}
        {step > 1 && (
          <button className="btn-back" onClick={() => setStep(step - 1)}>
            Back
          </button>
        )}
        <button className="btn-next" onClick={() => ValidateStep()}>
          {step < 4 ? "Next" : "Finish"}
        </button>
      </div>
    </div>
  );
}

export default NewProject;
